import { IconProps } from "./";
import Icon from "./assets/map_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Map(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
